// const END_POINT="http://127.0.0.1:3001/"
const END_POINT="https://srspdf.freyrkontractpro.com/"

export  {END_POINT}